// extracted by mini-css-extract-plugin
export default {"menuWrapper":"admin_menuWrapper__MSy7M","pageContent":"admin_pageContent__o7leC","adminContainer":"admin_adminContainer__x+T7V"};